import Ajax from 'js/utils/ajax/ajax';

export const getOrders = (identifier, customer, reference) =>
  Ajax.get(`/orders/v1`, { customer, reference, identifier });
